export const translations = {
    tp: {
        lang_tp: "toki pona",
        lang_sp: "󱥠󱥔",
        lang_en: "English",
        edit: "o ante",
        likes: "ijo olin",
        no: "ala",
        comment_edited: "jan li ante e toki ni.",
        comment_edit_success: "sina ante e toki!",
        follow_request_cancel: "o weka e wile kute",
        follow_requests: "wile kute",
        no_follow_requests: "wile kute li lon ala lon tenpo ni.",
        post_edit_success: "sina ante e lipu!",
        comment_edit_error: "pakala la mi ken ala ante e toki.",
        post_edit_error: "pakala la mi ken ala ante e lipu.",
        comment_delete_success: "toki li weka!",
        post_delete_success: "lipu li weka!",
        comment_delete_error: "pakala la mi ken ala weka e toki.",
        post_delete_error: "pakala la mi ken ala weka e lipu.",
        delete_error: "pakala la ilo li ken ala weka e toki.",
        confirm_delete_title: "sina wile ala wile weka e toki?",
        confirm_delete_description: "toki li weka la ona li ken ala kama sin.",
        confirm_delete_confirm: "o weka",
        likers_title: "jan ni li olin e ni",
        create_placeholder: "o toki e ijo...",
        alt_text_placeholder: "o toki e sitelen ni...",
        create_button: "o pana",
        create_error: "pakala la ilo li ken ala pana e toki.",
        image_error: "pakala la ilo li ken ala pana e sitelen sina.",
        post_text_error: "pakala la ilo li ken ala pana e toki.",
        post_error: "pakala la ilo li ken ala pana e toki.",
        add_image: "o pana e sitelen",
        change_image: "o ante e sitelen",
        post_edited: "jan li ante e lipu ni",
        comments: "toki",
        confirm_delete_title_post: "sina wile ala wile weka e lipu?",
        likers_title_post: "lipu li pona tawa jan ni",
        share_success: "sina kama jo e nimi pi lipu ni!",
        edit_post_heading: "o ante e lipu",
        post_text_label: "nimi lipu (≤ LLA 1000)",
        load_error: "pakala la ilo li ken ala pana e lipu.",
        post_text_required: "lipu o jo e nimi.",
        edit_profile_heading: "o ante e sona mi",
        username_label: "nimi insa",
        name_label: "nimi",
        bio_label: "sona mi",
        profile_picture_label: "sitelen mi",
        upload_image_button: "o pana e sitelen",
        change_image_button: "o ante e sitelen ni",
        new_password_label: "nimi len sin",
        confirm_password_label: "o pana sin e nimi len sin",
        current_password_label: "nimi len pi tenpo ni",
        save_button: "o pana",
        username_required: "nimi insa o lon.",
        username_length: "mute nimi pi nimi insa o suli tawa TW (3), o lili tawa M (20).",
        username_invalid_chars: "sitelen 'a-z' taso en sitelen 'A-Z' taso en sitelen '0-9' taso en o lon nimi insa.",
        username_taken: "jan ante li kepeken nimi insa ni. o kepeken nimi ante.",
        name_length: "mute nimi pi nimi sina o lili tawa LLMM (50).",
        name_invalid_chars: "nimi li ken kepeken sitelen pi toki pona anu sitelen pona taso.",
        current_password_required: "o pana e nimi len pi tenpo pini.",
        new_password_length: "mute nimi sin pi nimi len o suli tawa LTW (8), o lili tawa A (100).",
        new_password_complexity: "nimi len sin o jo e nimi wan e nanpa wan.",
        confirm_password_required: "o pana tu e nimi len.",
        confirm_password_mismatch: "nimi len tu li sama ala.",
        current_password_incorrect: "nimi len pi tenpo pini li ni ala.",
        update_error_generic: "pakala li lon. o alasa sin lon tenpo poka.",
        update_success: "ale li pona!",
        forgot_heading: "mi sona ala e nimi len mi",
        email_label: "lipu toki ilo",
        email_invalid: "ilo li sona ala e lipu toki ilo.",
        email_sent: "mi pana e toki ilo tawa sina.",
        send_email_button: "o pana e toki ilo",
        back_to_login: "mi tawa insa",
        login_heading: "o kama pona",
        password_label: "nimi len",
        forgot_password_link: "mi sona ala e nimi len mi.",
        login_button: "o pana",
        login_error: "nimi insa anu nimi len li ike.",
        signup_prompt: "sina sin anu seme?",
        signup_link: "o pali e lipu sina",
        register_heading: "o pali e lipu sin",
        register_button: "o pali",
        already_have_account: "sina sin ala anu seme?",
        login_link: "o kama pona",
        register_username_required: "nimi insa o lon.",
        register_username_length: "mute nimi pi nimi insa o suli tawa TW (3), o lili tawa M (20).",
        register_username_format: "sitelen 'a-z' taso en sitelen 'A-Z' taso en sitelen '0-9' taso o lon nimi insa.",
        register_username_taken: "jan ante li kepeken nimi insa ni. o kepeken nimi ante.",
        register_name_length: "mute nimi pi nimi sina o lili tawa LLMM (50).",
        register_name_format: "nimi li ken kepeken sitelen pi toki pona taso.",
        register_email_required: "nimi pi lipu ilo o lon.",
        register_email_format: "ilo li sona ala e nimi ni pi lipu ilo.",
        register_email_taken: "jan ante li kepeken lipu ilo ni. o kepeken nimi ante.",
        register_password_required: "nimi len o lon.",
        register_password_length: "mute nimi pi nimi len o suli tawa LTW (8), o lili tawa A (100).",
        register_password_format: "nimi len sin o jo e nimi wan e nanpa wan.",
        register_confirm_required: "o pana tu e nimi len.",
        register_confirm_mismatch: "nimi len tu li sama ala.",
        register_error: "pakala li lon. o pana sin.",
        reset_heading: "o ante e nimi len",
        password_label_new: "nimi len sin",
        reset_success: "sina ante e nimi len sina.",
        reset_error: "pakala la ilo li ken ala sin e nimi len sina.",
        edit_profile_button: "o ante e sona mi",
        logout_button: "mi weka",
        logout_confirm_title: "sin wile ala wile weka?",
        logout_confirm_yes: "wile",
        logout_confirm_no: "ala",
        follow: "o kute e jan ni",
        unfollow: "o kute ala",
        followers: "jan kute",
        followers_capitalized: "jan kute",
        following: "jan pi kute mi",
        following_capitalized: "jan pi kute mi",
        posts: "lipu",
        profile_not_found: "jan ni li lon ala",
        profile_not_found_desc_1: 'nimi insa "',
        profile_not_found_desc_2: '" li lon ala.',
        delete_account_button: "o weka e lipu mi",
        email_sent_heading: "o lukin e lipu ilo!",
        email_sent_description: "mi pana e lipu ilo tawa sina. o lukin e ona o pali e lipu sina.",
        email_confirm_success: "sina ken kepeken lipu sina. o kama pona.",
        email_confirm_error: "lipu ilo pi pana ken li ike.",
        discover: "o lukin e ijo sin",
        search_users_placeholder: "o alasa e jan...",
        info: "sona pi lipu pona",
        info_body:
            "mi pali e lipu ni tan wile ni: jan pi toki pona li ken jo e lipu kulupu ona. mi lili e lipu li pona e lipu. ni la, jan li ken pana e wile ona e sitelen ona li ken kama poka lon ma pona.",
        info_open_source: "jan ale li ken lukin e toki ilo insa pi lipu ni: ",
        info_toki_pona: "o kama sona e ijo namako pi toki pona: ",
        info_contact: "o toki tawa mi:\nnimi pi ilo Siko: qedized\nlipu toki ilo: contact@qedized.com",
        email_tooltip: "sina ken ala ante e ni.",
        email_placeholder: "nimi@kulupu.ijo",
        notification_title: "sin lipu",
        notification_like: "li olin e lipu sina.",
        notification_follow: "li kute e sina.",
        notification_follow_request: "li wile e ni: kute e sina.",
        notification_comment: "li toki lon toki sina.",
        notification_mention_post: "li toki e sina lon lipu ona.",
        notification_mention_comment: "li toki e sina lon toki ijo ona.",
        notification_fr_accepted: "li open e sona ona tawa sina.",
        notification_mark_read: "o pini e ale",
        notification_see_all: "o lukin e ale",
        liked_posts_title: "lipu pi olin sina",
        no_liked_posts: "sina olin ala e lipu.",
        edit_profile: "o ante e sona mi",
        account_settings: "sona pi lipu kulupu",
        notification_preferences: "wile pi toki sin",
        private_profile: "sona len",
        private_profile_description: "jan kute taso li ken lukin e lipu sina",
        private_profile_message: "ni li sona len.",
        private_post_message: "ni li lipu pi jan {username}. o kute e ona la sina ken lukin e lipu ni.",
        accept: "o ken",
        reject: "o ala",
        unfollow_private_confirm_title: "ni li sona len. sina wile pana e wile kute.",
        unfollow_private_confirm_button: "o pini kute",
        post_not_found: "lipu li lon ala anu weka.",
        notify_follow: "jan li kute e sina",
        notify_like: "jan li olin e lipu sina",
        notify_comment: "jan li toki lon lipu sina",
        notify_mention: "jan li toki e sina",
        notify_fr_accepted: "jan li open e sona ona tawa sina",
    },

    sp: {
        lang_tp: "toki pona",
        lang_en: "English",
        lang_sp: "󱥠󱥔",
        edit: "󱥄󱤆",
        likes: "󱤌󱥅",
        no: "󱤂",
        comment_edited: "󱤑󱤧󱤆󱤉󱥬󱥁󱦜",
        comment_edit_success: "󱥞󱤆󱤉󱥬󱦜",
        post_edit_success: "󱥞󱤆󱤉󱤪󱦜",
        comment_edit_error: "󱥈󱤡󱤴󱤘󱤂󱤆󱤉󱥬󱦜",
        post_edit_error: "󱥈󱤡󱤴󱤘󱤂󱤆󱤉󱤪󱦜",
        comment_delete_success: "󱥬󱤧󱥶󱦜",
        post_delete_success: "󱤪󱤧󱥶󱦜",
        comment_delete_error: "󱥈󱤡󱤴󱤘󱤂󱥶󱤉󱥬󱦜",
        post_delete_error: "󱥈󱤡󱤴󱤘󱤂󱥶󱤉󱤪󱦜",
        delete_error: "󱥈󱤡󱤎󱤧󱤘󱤂󱥶󱤉󱥬󱦜",
        confirm_delete_title: "󱥞󱥷󱤂󱥷󱥶󱤉󱥬󱦜",
        confirm_delete_description: "󱥬󱤧󱥶󱤡󱥆󱤧󱤘󱤂󱤖󱥝󱦜",
        confirm_delete_confirm: "󱥄󱥶",
        likers_title: "󱤑󱥁󱤧󱥅󱤉󱥁",
        create_placeholder: "󱥄󱥬󱤉󱤌󱦜󱦜󱦜",
        alt_text_placeholder: "󱥄󱥬󱤉󱥠󱥁󱦜󱦜󱦜",
        create_button: "󱥄󱥌",
        create_error: "󱥈󱤡󱤎󱤧󱤘󱤂󱥌󱤉󱥬󱦜",
        image_error: "󱥈󱤡󱤎󱤧󱤘󱤂󱥌󱤉󱥠󱥞󱦜",
        post_text_error: "󱥈󱤡󱤎󱤧󱤘󱤂󱥌󱤉󱥬󱦜",
        post_error: "󱥈󱤡󱤎󱤧󱤘󱤂󱥌󱤉󱥬󱦜",
        add_image: "󱥄󱥌󱤉󱥠",
        change_image: "󱥄󱤆󱤉󱥠",
        post_edited: "󱤑󱤧󱤆󱤉󱤪󱥁",
        comments: "󱥬",
        confirm_delete_title_post: "󱥞󱥷󱤂󱥷󱥶󱤉󱤪󱦜",
        likers_title_post: "󱤪󱤧󱥔󱥩󱤑󱥁",
        share_success: "󱥞󱤖󱤓󱤉󱥂󱥍󱤪󱥁󱦜",
        edit_post_heading: "󱥄󱤆󱤉󱤪",
        post_text_label: "󱥂󱤪(≤󱤭󱤭󱤄(1000))",
        load_error: "󱥈󱤡󱤎󱤧󱤘󱤂󱥌󱤉󱤪󱦜",
        post_text_required: "󱤪󱥄󱤓󱤉󱥂󱦜",
        edit_profile_heading: "󱥄󱤆󱤉󱥡󱤴",
        username_label: "󱥂󱤏",
        name_label: "󱥂",
        bio_label: "󱥡󱤴",
        profile_picture_label: "󱥠󱤴",
        upload_image_button: "󱥄󱥌󱤉󱥠",
        change_image_button: "󱥄󱤆󱤉󱥠󱥁",
        new_password_label: "󱥂󱤥󱥝",
        confirm_password_label: "󱥄󱥌󱥝󱤉󱥂󱤥󱥝",
        current_password_label: "󱥂󱤥󱥍󱥫󱥁",
        save_button: "󱥄󱥌",
        username_required: "󱥂󱤏󱥄󱤬󱦜",
        username_length: "󱤼󱥂󱥍󱥂󱤏󱥄󱥣󱥩󱥮󱥳(3), 󱥄󱤨󱥩󱤼(20)󱦜",
        username_invalid_chars: "󱥠'a-z'󱥨󱤊󱥠'A-Z'󱥨󱤊󱥠'0-9'󱥨󱤊󱥄󱤬󱥂󱤏󱦜",
        username_taken: "󱤑󱤆󱤧󱤙󱥂󱤏󱥁󱦜󱥄󱤙󱥂󱤆󱦜",
        name_length: "󱤼󱥂󱥍󱥂󱥞󱥄󱤨󱥩󱤭󱤭󱤼󱤼(50)󱦜",
        name_invalid_chars: "󱥂󱤧󱤘󱤙󱥠󱥍󱥬󱥔󱤇󱥠󱥔󱥨󱦜",
        current_password_required: "󱥄󱥌󱤉󱥂󱤥󱥍󱥫󱥐󱦜",
        new_password_length: "󱤼󱥂󱥝󱥍󱥂󱤥󱥄󱥣󱥩󱤭󱥮󱥳(8), 󱥄󱤨󱥩󱤄(100)󱦜",
        new_password_complexity: "󱥂󱤥󱥝󱥄󱤓󱤉󱥂󱥳󱤉󱤽󱥳󱦜",
        confirm_password_required: "󱥄󱥌󱥮󱤉󱥂󱤥󱦜",
        confirm_password_mismatch: "󱥂󱤥󱥮󱤧󱥖󱤂󱦜",
        current_password_incorrect: "󱥂󱤥󱥍󱥫󱥐󱤧󱥁󱤂󱦜",
        update_error_generic: "󱥈󱤧󱤬󱦜󱥄󱤃󱥝󱤬󱥫󱥒󱦜",
        update_success: "󱤄󱤧󱥔󱦜",
        forgot_heading: "󱤴󱥡󱤂󱤉󱥂󱤥󱤴",
        email_label: "󱤪󱥬󱤎",
        email_invalid: "󱤎󱤧󱥡󱤂󱤉󱤪󱥬󱤎󱦜",
        email_sent: "󱤴󱥌󱤉󱥬󱤎󱥩󱥞󱦜",
        send_email_button: "󱥄󱥌󱤉󱥬󱤎",
        back_to_login: "󱤴󱥩󱤏",
        login_heading: "󱥄󱤖󱥔",
        password_label: "󱥂󱤥",
        forgot_password_link: "󱤴󱥡󱤂󱤉󱥂󱤥󱤴󱦜",
        login_button: "󱥄󱥌",
        login_error: "󱥂󱤏󱤇󱥂󱤥󱤧󱤍󱦜",
        signup_prompt: "󱥞󱥝󱤇󱥙󱦜",
        signup_link: "󱥄󱥉󱤉󱤪󱥞",
        register_heading: "󱥄󱥉󱤉󱤪󱥝",
        register_button: "󱥄󱥉",
        already_have_account: "󱥞󱥝󱤂󱤇󱥙󱦜",
        login_link: "󱥄󱤖󱥔",
        register_username_required: "󱥂󱤏󱥄󱤬󱦜",
        register_username_length: "󱤼󱥂󱥍󱥂󱤏󱥄󱥣󱥩󱥮󱥳(3), 󱥄󱤨󱥩󱤼(20)󱦜",
        register_username_format: "󱥠'a-z'󱥨󱤊󱥠'A-Z'󱥨󱤊󱥠'0-9'󱥨󱥄󱤬󱥂󱤏󱦜",
        register_username_taken: "󱤑󱤆󱤧󱤙󱥂󱤏󱥁󱦜󱥄󱤙󱥂󱤆󱦜",
        register_name_length: "󱤼󱥂󱥍󱥂󱥞󱥄󱤨󱥩󱤭󱤭󱤼󱤼(50)󱦜",
        register_name_format: "󱥂󱤧󱤘󱤙󱥠󱥍󱥬󱥔󱥨󱦜",
        register_email_required: "󱥂󱥍󱤪󱤎󱥄󱤬󱦜",
        register_email_format: "󱤎󱤧󱥡󱤂󱤉󱥂󱥁󱥍󱤪󱤎󱦜",
        register_email_taken: "󱤑󱤆󱤧󱤙󱤪󱤎󱥁󱦜󱥄󱤙󱥂󱤆󱦜",
        register_password_required: "󱥂󱤥󱥄󱤬󱦜",
        register_password_length: "󱤼󱥂󱥍󱥂󱤥󱥄󱥣󱥩󱤭󱥮󱥳(8),󱥄󱤨󱥩󱤄(100)󱦜",
        register_password_format: "󱥂󱤥󱥝󱥄󱤓󱤉󱥂󱥳󱤉󱤽󱥳󱦜",
        register_confirm_required: "󱥄󱥌󱥮󱤉󱥂󱤥󱦜",
        register_confirm_mismatch: "󱥂󱤥󱥮󱤧󱥖󱤂󱦜",
        register_error: "󱥈󱤧󱤬󱦜󱥄󱥌󱥝󱦜",
        reset_heading: "󱥄󱤆󱤉󱥂󱤥",
        password_label_new: "󱥂󱤥󱥝",
        reset_success: "󱥞󱤆󱤉󱥂󱤥󱥞󱦜",
        reset_error: "󱥈󱤡󱤎󱤧󱤘󱤂󱥝󱤉󱥂󱤥󱥞󱦜",
        edit_profile_button: "󱥄󱤆󱤉󱥡󱤴",
        logout_button: "󱤴󱥶",
        logout_confirm_title: "󱥝󱥷󱤂󱥷󱥶󱦜",
        logout_confirm_yes: "󱥷",
        logout_confirm_no: "󱤂",
        follow: "󱥄󱤠󱤉󱤑󱥁",
        unfollow: "󱥄󱤠󱤂",
        followers: "󱤑󱤠",
        followers_capitalized: "󱤑󱤠",
        following: "󱤑󱥍󱤠󱤴",
        following_capitalized: "󱤑󱥍󱤠󱤴",
        posts: "󱤪",
        profile_not_found: "󱤑󱥁󱤧󱤬󱤂",
        profile_not_found_desc_1: '󱥂󱤏"',
        profile_not_found_desc_2: '"󱤧󱤬󱤂󱦜',
        delete_account_button: "󱥄󱥶󱤉󱤪󱤴",
        email_sent_heading: "󱥄󱤮󱤉󱤪󱤎󱦜",
        email_sent_description: "󱤴󱥌󱤉󱤪󱤎󱥩󱥞󱦜󱥄󱤮󱤉󱥆󱥄󱥉󱤉󱤪󱥞󱦜",
        email_confirm_success: "󱥞󱤘󱤙󱤪󱥞󱦜󱥄󱤖󱥔󱦜",
        email_confirm_error: "󱤪󱤎󱥍󱥌󱤘󱤧󱤍󱦜",
        discover: "󱥄󱤮󱤉󱤌󱥝",
        search_users_placeholder: "󱥄󱤃󱤉󱤑󱦜󱦜󱦜",
        info: "󱥡󱥍󱤪󱥔",
        info_body: "󱤴󱥉󱤉󱤪󱥁󱥧󱥷󱥁: 󱤑󱥍󱥬󱥔󱤧󱤘󱤓󱤉󱤪󱤟󱥆󱦜󱤴󱤨󱤉󱤪󱤧󱥔󱤉󱤪󱦜󱥁󱤡,󱤑󱤧󱤘󱥌󱤉󱥷󱥆󱤉󱥠󱥆󱤧󱤘󱤖󱥒󱤬󱤰󱥔󱦜",
        info_open_source: "󱤑󱤄󱤧󱤘󱤮󱤉󱥬󱤎󱤏󱥍󱤪󱥁: ",
        info_toki_pona: "󱥄󱤖󱥡󱤉󱤌󱥸󱥍󱥬󱥔: ",
        info_contact: "󱥄󱥬󱥩󱤴:\n󱥂󱥍󱤎Siko: qedized\n󱤪󱥬󱤎: contact@qedized󱦜com",
        email_tooltip: "󱥞󱤘󱤂󱤆󱤉󱥁󱦜",
        email_placeholder: "󱥂@󱤟.󱤌",
        notification_title: "󱥝󱤪",
        notification_like: "󱤧󱥅󱤉󱤪󱥞󱦜",
        notification_follow: "󱤧󱤠󱤉󱥞󱦜",
        notification_follow_request: "󱤧󱥷󱤉󱥁: 󱤠󱤉󱥞󱦜",
        notification_comment: "󱤧󱥬󱤬󱥬󱥞󱦜",
        notification_mention_post: "󱤧󱥬󱤉󱥞󱤬󱤪󱥆󱦜",
        notification_mention_comment: "󱤧󱥬󱤉󱥞󱤬󱥬󱤌󱥆󱦜",
        notification_fr_accepted: "󱤧󱥇󱤉󱥡󱥆󱥩󱥞󱦜",
        notification_mark_read: "󱥄󱥐󱤉󱤄",
        notification_see_all: "󱥄󱤮󱤉󱤄",
        liked_posts_title: "󱤪󱥔󱥅󱥞",
        no_liked_posts: "󱥞󱥅󱤄󱤉󱤪󱦜",
        edit_profile: "󱥄󱤆󱤉󱥡󱤴",
        account_settings: "󱥡󱥍󱤪󱤟",
        notification_preferences: "󱥷󱥍󱥬󱥝",
        private_profile: "󱥡󱤮󱤂",
        private_profile_description: "󱤑󱤠󱥬󱤉󱤔󱤮󱤉󱤪󱥞",
        private_profile_message: "󱤝󱤧󱥡󱤮󱤂󱦜",
        private_post_message: "󱤝󱤧󱤪󱥔󱤑 {username}󱦜 󱥄󱤠󱤉󱥆󱤡󱥞󱤔󱤮󱤉󱤪󱤝󱦜",
        follow_request_cancel: "󱥄󱥶󱤉󱥷󱤠",
        follow_request_again: "󱥷󱤠󱥚",
        follow_requests: "󱥷󱤠",
        no_follow_requests: "󱥷󱤠󱤧󱤬󱤄󱤬󱥫󱥁󱦜",
        accept: "󱥄󱤔",
        reject: "󱥄󱤄",
        unfollow_private_confirm_title: "󱤝󱤧󱥡󱤮󱤂󱦜󱥞󱥷󱥄󱥚󱤉󱥷󱤠󱦜",
        unfollow_private_confirm_button: "󱥄󱥐󱤠",
        post_not_found: "󱤪󱤧󱤬󱤄󱤇󱥷󱦜",
        notify_follow: "󱤑󱤧󱤠󱤉󱥞",
        notify_like: "󱤑󱤧󱥅󱤉󱤪󱥞",
        notify_comment: "󱤑󱤧󱥬󱤬󱤪󱥞",
        notify_mention: "󱤑󱤧󱥬󱤉󱥞",
        notify_fr_accepted: "󱤑󱤧󱥇󱤉󱥡󱥆󱥩󱥞",
    },

    en: {
        lang_tp: "toki pona",
        lang_sp: "󱥠󱥔",
        lang_en: "English",
        edit: "Edit",
        likes: "likes",
        no: "No",
        comment_edited: "edited",
        comment_edit_success: "Comment updated!",
        post_edit_success: "Post updated!",
        comment_edit_error: "Error: could not update comment.",
        post_edit_error: "Error: could not update post.",
        comment_delete_success: "Comment deleted!",
        post_delete_success: "Post deleted!",
        comment_delete_error: "Error: could not delete comment.",
        post_delete_error: "Error: could not delete post.",
        confirm_delete_title: "Delete this comment?",
        confirm_delete_description: "This cannot be undone.",
        confirm_delete_confirm: "Delete",
        likers_title: "These people liked this comment",
        create_placeholder: "Say something...",
        alt_text_placeholder: "Describe your image...",
        create_button: "Post",
        create_error: "Error: could not create comment.",
        image_error: "Image error! Compression failed.",
        post_text_error: "Text is invalid.",
        post_error: "Error: could not create post.",
        add_image: "Add image",
        change_image: "Change image",
        post_edited: "edited",
        comments: "comments",
        confirm_delete_title_post: "Delete this post?",
        likers_title_post: "These people liked this post",
        share_success: "Link copied!",
        edit_post_heading: "Edit Post",
        post_text_label: "Post text (≤ 1000)",
        load_error: "Error: could not load post.",
        post_text_required: "Post text is required.",
        edit_profile_heading: "Edit Profile",
        username_label: "Username",
        name_label: "Name",
        bio_label: "Bio",
        profile_picture_label: "Profile picture",
        upload_image_button: "Upload image",
        change_image_button: "Change this image",
        new_password_label: "New Password",
        confirm_password_label: "Confirm Password",
        current_password_label: "Current Password",
        save_button: "Save",
        username_required: "Username is required.",
        username_length: "Username must be 3-20 characters.",
        username_invalid_chars: "Username may only contain letters (a-z, A-Z) and numbers (0-9).",
        username_taken: "That username is already taken. Choose another.",
        name_length: "Name must be 0-50 characters.",
        name_invalid_chars: "Name must use toki pona letters (or sitelen pona) only.",
        current_password_required: "Current password is required.",
        new_password_length: "Password must be 8-100 characters.",
        new_password_complexity: "Password must contain at least one letter and one number.",
        confirm_password_required: "Please confirm the new password.",
        confirm_password_mismatch: "Passwords do not match.",
        current_password_incorrect: "Current password is incorrect.",
        update_error_generic: "Error: please try again.",
        update_success: "Profile updated!",
        forgot_heading: "I forgot my password",
        email_label: "Email",
        email_invalid: "Please enter a valid email address.",
        email_sent: "Alright. I've sent you an email.",
        send_email_button: "Send email",
        back_to_login: "Back to login",
        login_heading: "Log In",
        password_label: "Password",
        forgot_password_link: "Forgot your password?",
        login_button: "Log In",
        login_error: "Invalid username or password",
        signup_prompt: "New here?",
        signup_link: "Create an account",
        register_heading: "Register",
        register_button: "Register",
        already_have_account: "Already have an account?",
        login_link: "Log in",
        register_username_required: "Username is required.",
        register_username_length: "Username must be 3-20 characters.",
        register_username_format: "Username must contain only letters and numbers.",
        register_username_taken: "That username is taken. Please choose another.",
        register_name_length: "Name must be between 0-50 characters.",
        register_name_format: "Name must use only toki pona letters.",
        register_email_required: "Email is required.",
        register_email_format: "Please enter a valid email.",
        register_email_taken: "That email is already registered.",
        register_password_required: "Password is required.",
        register_password_length: "Password must be 8-100 characters.",
        register_password_format: "Password must contain at least one letter and one number.",
        register_confirm_required: "Please confirm your password.",
        register_confirm_mismatch: "Passwords do not match.",
        register_error: "Something went wrong. Try again with a different password.",
        reset_heading: "Reset your password",
        password_label_new: "New password",
        reset_success: "Password updated.",
        reset_error: "Something went wrong. Link may be invalid.",
        edit_profile_button: "Edit Profile",
        logout_button: "Log Out",
        logout_confirm_title: "Are you sure you want to log out?",
        logout_confirm_yes: "Yes",
        logout_confirm_no: "No",
        follow: "Follow",
        posts: "posts",
        unfollow: "Unfollow",
        followers: "followers",
        followers_capitalized: "Followers",
        following: "following",
        following_capitalized: "Following",
        profile_not_found: "User Not Found",
        profile_not_found_desc_1: "The user @",
        profile_not_found_desc_2: " does not exist.",
        delete_account_button: "Delete My Account",
        email_sent_heading: "Check your email!",
        email_sent_description:
            "We've sent you a link to confirm your email address. Open it to activate your account.",
        email_confirm_success: "Your account is now active. Please log in.",
        email_confirm_error: "Activation link is invalid or expired.",
        discover: "Discover",
        search_users_placeholder: "Search users...",
        info: "Information about lipu pona",
        info_body:
            "lipu pona is a social media platform designed for the toki pona community. The main focus is on simplicity and ease of use, allowing users to share their thoughts, images, and connect with others in a friendly environment.",
        info_open_source: "This website is open source: ",
        info_toki_pona: "Learn more about toki pona: ",
        info_contact: `Contact me:\nDiscord: qedized\nEmail: contact@qedized.com`,
        email_tooltip: "You cannot change your email.",
        email_placeholder: "name@domain.tld",
        notification_title: "Notifications",
        notification_like: "liked your post.",
        notification_follow: "started following you.",
        notification_follow_request: "wants to follow you.",
        notification_comment: "commented on your post.",
        notification_mention_post: "mentioned you in their post.",
        notification_mention_comment: "mentioned you in their comment.",
        notification_fr_accepted: "accepted your follow request.",
        notification_mark_read: "Mark all as read",
        notification_see_all: "See all",
        liked_posts_title: "Liked Posts",
        no_liked_posts: "You haven't liked any posts yet.",
        edit_profile: "Edit Profile",
        account_settings: "Account Settings",
        notification_preferences: "Notification Preferences",
        private_profile: "Private Profile",
        private_profile_description: "Only followers can see your posts",
        private_profile_message: "This profile is set to private.",
        private_post_message: "This is @{username}'s post. Follow them to see this post.",
        follow_request_cancel: "Cancel Follow Request",
        follow_requests: "Follow Requests",
        no_follow_requests: "No follow requests at the moment.",
        accept: "Accept",
        reject: "Reject",
        unfollow_private_confirm_title: "This profile is private. You will have to send a follow request.",
        unfollow_private_confirm_button: "Unfollow",
        post_not_found: "Post not found or has been deleted.",
        notify_follow: "New followers",
        notify_like: "Post likes",
        notify_comment: "Post comments",
        notify_mention: "Mentions",
        notify_fr_accepted: "Follow requests accepted",
    },
};
